import React, { Component } from 'react';
import { ReactComponent as Arrow } from '../../../images/back.svg';
import {
	SpanRow,
	InfoSpan,
	EmailOrPhoneInput,
	ActionButton,
	ConfirmationText,
	CallToActionButton,
	ConfirmationFormRow,
	BackButton,
	TransferTicketFormRow,
	TransferTicketCallToActionButton,
	ValidationError
} from './Ticket';
import { Validation } from '../../../utils/validation';
import { ActionInfo } from './ActionInfoText';

export class TransferTicketForm extends Component {
	state = {
		emailOrPhone: '',
		disableButton: true,
		showConfirmation: false,
		errorMessage: '',
	};

	handleChange = e => {
		const emailOrPhone = e.value;
		const state = { emailOrPhone };

		if (
			Validation.mobile.test(emailOrPhone) ||
			Validation.email.test(emailOrPhone)
		) {
			state.disableButton = false;
			state.errorMessage = '';
		} else {
			state.disableButton = true;
			state.errorMessage = 'E-post eller mobilnummer är angett i fel format. Ange e-post (exemple.exemple@mejl.com) eller mobilnummer (46701234567).';
		}

		this.setState(state);
	};

	transferTicket = () => {
		const { product } = this.props;
		const input = this.state.emailOrPhone;
		const transferModel = {};

		if (Validation.mobile.test(input)) {
			transferModel.phoneNumber = input;
		} else if (Validation.email.test(input)) {
			transferModel.email = input;
		}

		this.props.onTransferTicket(transferModel, product.id);
	};

	toggleConfirmation = () => {
		this.setState({ showConfirmation: true });
	};

	cancel = () => {
		this.setState(
			{
				showConfirmation: false,
				emailOrPhone: '',
				disableButton: true,
				errorMessage: '',
			},
			this.props.onBackClick
		);
	};

	enterPressed = e => {
		if (e.key === 'Enter') {
			this.toggleConfirmation();
		}
	};

	render() {
		const {
			disableButton,
			emailOrPhone,
			showConfirmation,
			errorMessage,
		} = this.state;

		if (showConfirmation) {
			return (
				<>
					<SpanRow>
						<Arrow aria-hidden="true" focusable="false" alt="" />
						<span>Överlåt biljett</span>
					</SpanRow>
					<ConfirmationText>
						{
							this.props.texts.private.ticketpage.tickets
								.transferticketconfirmation
						}{' '}
						{emailOrPhone}
					</ConfirmationText>
					<ConfirmationFormRow>
						<CallToActionButton onClick={this.transferTicket}>
							{this.props.texts.private.ticketpage.tickets.transferticketaccept}
						</CallToActionButton>
						<ActionButton onClick={this.cancel}>Avbryt</ActionButton>
					</ConfirmationFormRow>
					<BackButton onClick={this.cancel}>&lsaquo; Tillbaka</BackButton>
				</>
			);
		}

		return (
			<>
				<SpanRow>
					<Arrow aria-hidden="true" focusable="false" alt="" />
					<span>Överlåt biljett</span>
				</SpanRow>
				<ActionInfo>
					{this.props.texts.private.ticketpage.tickets.transferticketinformation}
				</ActionInfo>
				<InfoSpan>
					<span>
						{this.props.texts.private.ticketpage.tickets.emailorphone}{' '}
					</span>
					<span>*</span>
				</InfoSpan>
				<ValidationError>{errorMessage}</ValidationError>
				<TransferTicketFormRow>
					<EmailOrPhoneInput
						type="text"
						value={emailOrPhone}
						handleChange={this.handleChange}
						onKeyPress={this.enterPressed}
						// errorMessage={errorMessage || ""}
						// isError={errorMessage.length > 0}
					/>
					<TransferTicketCallToActionButton
						style={{padding: "0.7em 3em"}}
						disabled={disableButton}
						onClick={this.toggleConfirmation}
					>
						Överlåt
					</TransferTicketCallToActionButton>
				</TransferTicketFormRow>
				<BackButton whiteSpace onClick={this.cancel}>&lsaquo; Tillbaka</BackButton>
			</>
		);
	}
}
